import React from "react";
import { Form } from "react-bootstrap";
import { CheckmarkIcon } from "../Icons/Arrows/CheckmarkIcon";
import "./Checkbox.scss";

/**
 * Componente Checkbox personalizado
 * @param {Object} props - Props del componente
 * @param {string} props.id - ID único del checkbox para asociar con el label
 * @param {boolean} props.checked - Estado del checkbox (seleccionado o no)
 * @param {Function} props.onChange - Función ejecutada cuando cambia el estado del checkbox
 * @param {boolean} [props.disabled=false] - Estado deshabilitado del checkbox
 * @param {string} [props.className=''] - Clases CSS adicionales para el contenedor
 * @param {string} [props.labelClassName=''] - Clases CSS adicionales para el label
 * @param {React.ReactNode} [props.children] - Contenido del label (texto o elementos)
 * @param {Object} [...props] - Props adicionales que se pasan al input checkbox
 * @returns {JSX.Element} Componente Checkbox
 */
export const Checkbox = ({
  id,
  checked,
  onChange,
  disabled = false,
  className = "",
  labelClassName = "",
  children,
  ...props
}) => {
  return (
    <Form.Check className={`checkbox-container ${className}`}>
      <div className="checkbox-wrapper">
        <Form.Check.Input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="checkbox-custom"
          {...props}
        />
        {checked && (
          <div className="checkbox-icon">
            <CheckmarkIcon />
          </div>
        )}
      </div>
      <Form.Check.Label
        htmlFor={id}
        className={`label-custom ${labelClassName}`}
      >
        {children}
      </Form.Check.Label>
    </Form.Check>
  );
};
